import { useSeoStore } from '~/store/seo';

export const useHeadWithSeo = () => {
  const seoStore = useSeoStore();

  const { title, description, canonical, schema, og_image, site_icon, robots } =
    seoStore.currentSeo;
  const ldJsonContent: string = schema?.replace(/<script.*?>(.*)<\/script>/, '$1') ?? '';

  useHead({
    title,

    meta: [
      { key: 'og:title', property: 'og:title', content: title },
      {
        key: 'og:image',
        property: 'og:image',
        content: og_image || site_icon,
      },
      {
        key: 'og:description',
        property: 'og:description',
        content: description,
      },
      { key: 'og:url', property: 'og:url', content: canonical },
      { key: 'description', name: 'description', content: description },
      {
        key: 'robots',
        name: 'robots',
        content: robots,
      },
      // twiiter
      { key: 'twitter:title', property: 'twitter:title', content: title },
      {
        key: 'twitter:description',
        property: 'twitter:description',
        content: description,
      },
      {
        key: 'twitter:card',
        property: 'twitter:card',
        content: 'summary_large_image',
      },
      { key: 'twitter:image', property: 'twitter:image', content: og_image },
    ],

    script: [
      {
        type: 'application/ld+json',
        class: 'yoast-schema-graph yoast-schema-graph--main',
        innerHTML: ldJsonContent,
      },
    ],

    link: [{ key: 'canonical', rel: 'canonical', href: canonical }],

    __dangerouslyDisableSanitizers: ['script'],
  });
};
